import { generateThemeCSS } from './theme';

/**
 * Inject theme CSS variables into the DOM
 * This should be called once at application startup
 */
export function injectTheme() {
    // Create a style element
    const styleId = 'theme-variables';

    // Remove existing theme style if present (for hot reload)
    const existingStyle = document.getElementById(styleId);
    if (existingStyle) {
        existingStyle.remove();
    }

    // Create new style element
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = generateThemeCSS();

    // Append to head
    document.head.appendChild(style);
}

/**
 * Update theme dynamically (useful for hot reload in development)
 */
export function updateTheme() {
    injectTheme();
}
